module.exports = __webpack_public_path__ + "static/media/android.e5c4ba08.svg";